<template>
  <div>
    <Return :goHistory="false" :id="record_id" />
    <div class="bodyControll">
      <div class="steps">
        <Step :step="2" />
      </div>
      <div class="them" style="margin-top: 28px">
        <div class="line"></div>
        {{ year }}年度业绩信息
      </div>
      <div class="box">
        <div class="each">
          <div class="t">年度项目总数</div>
          <div class="n">{{ project_count }}</div>
        </div>
        <div class="cutOff"></div>
        <div class="each">
          <div class="t">年度工程造价营业收入(万)</div>
          <div class="n"><span>￥</span>{{ project_income }}</div>
        </div>
      </div>
      <div class="btnControll">
        <el-button class="add" type="text" @click="addYj()"
          >新增业绩
        </el-button>
      </div>
      <SkkCreatePer
        :detailShow="edit"
        :add.sync="dialogVisible"
        :idx="idx"
        :rowId="rowId"
        :tableData.sync="tableData"
        :recordId="record_id"
        @upPage="upShow"
      />
      <el-table :data="tableData" class="tableControll" empty-text="暂无数据">
        <el-table-column prop="address" align="center" label="序号">
          <template slot-scope="scope">
            <span>
              {{ scope.$index + 1 }}
              <!--              {{ scope.row }}-->
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="项目名称" align="center">
        </el-table-column>
        <el-table-column align="center" label="项目起止时间">
          <template slot-scope="scope">
            <span class="handle"
              >{{
                `${scope.row.start_time ? scope.row.start_time : "--"}至${
                  scope.row.finish_time ? scope.row.finish_time : "--"
                }`
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="money" align="center" label="收费金额(万)">
        </el-table-column>
        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <span
              class="handle green"
              v-if="
                scope.row.name &&
                scope.row.type &&
                scope.row.amount &&
                scope.row.bill_code &&
                scope.row.company &&
                scope.row.money &&
                scope.row.money_time &&
                scope.row.ratio &&
                scope.row.finish_time &&
                scope.row.service1 &&
                scope.row.service2 &&
                scope.row.start_time &&
                scope.row.technical_name &&
                scope.row.technical_tel
              "
              >已完成</span
            >
            <span class="handle red" v-else>未完成</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" align="center" label="操作">
          <template slot-scope="scope">
            <div class="handle">
              <!--              <el-link-->
              <!--                @click="handlerEdit(scope.$index, true)"-->
              <!--                style="margin-left: 10px"-->
              <!--                >查看-->
              <!--              </el-link>-->
              <el-link
                @click="handlerEdit(scope.$index, scope.row.id)"
                style="margin-left: 20px"
                >编辑
              </el-link>
              <!--              <el-link-->
              <!--                @click="handlerDelete(scope.$index)"-->
              <!--                style="margin-left: 20px"-->
              <!--                >删除-->
              <!--              </el-link>-->
              <el-popconfirm
                title="确定删除这条业绩吗？"
                @confirm="handlerDelete(scope.$index, scope.row.id)"
              >
                <el-button
                  slot="reference"
                  type="danger"
                  style="margin-left: 20px"
                  >删除
                </el-button>
              </el-popconfirm>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="btnControll">
        <div @click="saveYj" class="save">保存业绩</div>
      </div>
    </div>
  </div>
</template>

<script>
import Return from "@/components/record/Return";
import Step from "@/components/record/Step";
import SkkCreatePer from "@/components/record/SkkCreatePer";
import { perList, delEachRow } from "@/api/yj";

export default {
  name: "yjIndex",
  components: {
    Return,
    Step,
    SkkCreatePer,
  },
  computed: {
    // 总数
    project_count() {
      let num = this.tableData.length;
      return num;
    },
    // 总金额
    project_income() {
      let Decimal = require("decimal");
      let num = 0;
      for (let i = 0; i < this.tableData.length; i++) {
        let a = this.tableData[i].money;
        if (a == null) {
          a = 0;
        }
        // num += parseFloat(this.tableData[i].money);
        num = Decimal(a).add(num).toNumber();
      }
      return num;
    },
  },
  async created() {
    console.log("created");

    if (this.$route.query.record_id) {
      this.record_id = Number(this.$route.query.record_id);
    }
    //总列表是哪一行的index
    this.index = parseInt(this.$route.query.index);
    // 当前年份是哪一年
    this.year = parseInt(this.$route.query.year);
    // 加载列表页
    const reData = await perList(this.year, this.$route.query.record_id);
    console.log(reData, "reData");
    if (reData.project) {
      console.log(reData.project, "reData.project");
      this.tableData = reData.project;
    }
  },
  data() {
    return {
      visible: false,
      record_id: null,
      edit: false, // 表单是否是编辑模式
      dialogVisible: false, // 是否显示弹窗
      tableData: [], // 表格中的数据
      idx: -1, // 当前正在被编辑的数据index
      rowId: null, //当前正在被编辑的这行的id
      index: 0, // 当前在编辑哪一条数据
      year: 0, //是哪一年
      canSubmit: true, //弹出不同类型提示语
    };
  },
  watch: {
    // tableData(val) {
    //   // console.log(val, "val");
    //   val.forEach((item) => {
    //     console.log(item);
    //   });
    // },
  },
  methods: {
    async upShow() {
      // 加载列表页
      const reData = await perList(this.year, this.$route.query.record_id);
      console.log(reData, "reData");
      if (reData.project) {
        console.log(reData.project, "reData.project");
        this.tableData = reData.project;
      }
    },
    //保存业绩
    async saveYj() {
      // console.log(this.tableData, "this.外面点击保存业绩");
      // console.log("只 提交编辑的 业绩");
      // for (let [index, item] of this.tableData.entries()) {
      //   console.log(item, "item");
      //   console.log(index, "index");

      //只 提交编辑的 业绩
      //有多少条数据就请求多少次编辑接口（用编辑每一条的接口）
      // if (item.id) {
      //   try {
      //     const res = await editEach({
      //       project: JSON.stringify(item),
      //       id: item.id,
      //       record_id: this.record_id,
      //     });
      //     if (res.result && res.result == 9) {
      //       console.log("excel过来的这条报错了");
      //       if (item.name) {
      //         this.$message.error(
      //           `第${index + 1}条，${item.name}项目填写出错！`
      //         );
      //       } else {
      //         this.$message.error(`${index + 1}条填写出错！`);
      //       }
      //     }
      //   } catch (e) {
      //     //编辑报错
      //     console.log(e, "错误了");
      //   }
      // }
      // }
      console.log(this.tableData);
      //
      // const table_lines = [
      //   "name",
      //   "type",
      //   "amount",
      //   "bill_code",
      //   "company",
      //   "money",
      //   "money_time",
      //   "ratio",
      //   "finish_time",
      //   "service1",
      //   "start_time",
      //   "technical_name",
      //   "technical_tel",
      // ];
      //判断是否有还未填写完的
      this.tableData.forEach((item) => {
        for (let it in item) {
          if ((item[it] === null || item[it] === "") && it !== "service3") {
            console.log(it, "><<><><><><><><>", item[it], item);
            this.canSubmit = false;
          }
        }
      });
      if (this.canSubmit) {
        this.$message.success("保存成功！");
      } else {
        this.$message.warning("您还有未完成的项目，请完善信息。");
        this.canSubmit = true;
      }
    },
    // 编辑
    handlerEdit(ind, id, edit = false) {
      this.edit = edit;
      this.idx = ind; //每一行的索引
      this.rowId = id; //每一行的id
      this.dialogVisible = true;
    },
    //新增业绩
    addYj() {
      this.$router.push({
        name: "yjAdd",
        query: { record_id: this.record_id, year: this.year },
      });
    },
    // 删除
    async handlerDelete(ind, id) {
      await delEachRow(id);
      this.$message.success("删除成功！");
      this.tableData.splice(ind, 1);
    },
  },
};
</script>

<style lang="less" scoped>
.bodyControll {
  background: #ffffff;
  border-radius: 2px;
  padding: 20px 40px 40px 40px;
  margin-top: 10px;

  .steps {
    border-bottom: 1px solid #dddddd;
    padding: 0 149px 24px;
  }

  .box {
    width: 100%;
    height: 76px;
    background: #ffffff;
    border: 1px solid #e1e8f9;
    border-radius: 2px;
    box-shadow: 0px 0px 6px 0px rgba(151, 190, 255, 0.2);
    padding: 13px 0;
    box-sizing: border-box;
    margin-top: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .cutOff {
      width: 1px;
      height: 50px;
      background: #dddddd;
    }

    .each {
      flex: 1;
      text-align: center;

      .t {
        font-size: 12px;
        color: #666666;
      }

      .n {
        margin-top: 2px;
        font-size: 20px;
        color: #333333;
        font-family: "BEBAS";

        span {
          font-size: 14px;
          color: #333333;
        }
      }
    }
  }

  .btnControll {
    display: flex;
    align-items: center;
  }

  .them {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    font-size: 14px;
    font-weight: 700;
    color: #333333;
    padding-left: 15px;

    .line {
      width: 4px;
      height: 16px;
      background: #4379f6;
      left: 0px;
      position: absolute;
    }

    .bur {
      font-size: 12px;
      color: #333333;
    }

    .des {
      font-size: 14px;
      color: #666666;
      margin-left: 20px;
      font-weight: 400;
    }
  }

  .add {
    border-radius: unset;
    width: 100px;
    height: 32px;
    background: #4379f6;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    color: #ffffff;
    margin-top: 18px;
  }

  .lead {
    background: #4796e4;
    margin-left: 20px;
  }

  .tableControll {
    width: 100%;
    border: solid 1px rgb(235, 238, 245);
    border-bottom: unset;
    margin-top: 10px;
  }

  /deep/ .el-table th {
    background: #f6f6f6 !important;
    color: #666;
    font-weight: normal;
  }

  /deep/ .el-table tr {
    color: #333 !important;
    font-size: 12px;
  }

  /deep/ .el-table__empty-text {
    line-height: unset;
  }

  .btnControll {
    display: flex;
    align-items: center;

    div {
      margin-top: 40px;
      width: 100px;
      height: 38px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    .text {
      margin-left: 10px !important;
    }

    .save {
      background: #f39020;
      color: #fff;
    }
  }

  /deep/ .el-button {
    padding: 10px;
  }

  /deep/ .el-popconfirm_action {
    margin: unset !important;
    margin-bottom: 10px !important;
  }

  /deep/ .el-button--mini {
    margin-top: 10px !important;
  }

  .green {
    color: #67c23a;
  }

  .red {
    color: red;
  }
}
</style>
